import selectFavoriteCategory from '../actions/selectFavoriteCategory';
import selectFolder from '../actions/selectFolder';
import selectGroup from '../actions/selectGroup';
import selectPersona from '../actions/selectPersona';
import selectPreviousNodeInternal from '../actions/selectPreviousNodeInternal';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { mailSearchStore } from 'owa-mail-search';
import { orchestrator } from 'satcheljs';
export default orchestrator(selectPreviousNodeInternal, function (actionMessage) {
    var actionSource = actionMessage.actionSource;
    // Select previous node if it was set, or the current selected node.
    // VSO #15945 - We should try to merge SelectFolder and SelectPersona logic.
    var folderNodeToSelect = mailSearchStore.previousNode || getSelectedNode();
    switch (folderNodeToSelect.type) {
        case 1 /* Persona */:
            selectPersona(folderNodeToSelect.id);
            break;
        case 0 /* Folder */:
            selectFolder(folderNodeToSelect.id, folderNodeToSelect.treeType, actionSource);
            break;
        case 4 /* Category */:
            selectFavoriteCategory(folderNodeToSelect.id);
            break;
        case 2 /* Group */:
            selectGroup(folderNodeToSelect.id, folderNodeToSelect.treeType);
            break;
        default:
            throw new Error('exitSearchOrchestrator: Unknown node type');
    }
});
//# sourceMappingURL=selectPreviousNodeInternalOrchestrator.js.map